
import React, { useState } from "react";
import { Typography, Box, TextField, Button } from "@mui/material";
import { BUTTON_STYLES } from "../styles/buttonStyles";
import { useTheme } from "../util/themes";

interface NewsletterSignupProps {
  title?: string;
  description?: string;
  successMessage?: string;
}

export default function NewsletterSignup({ 
  title = "Recibí todas las ofertas",
  description = "¿Quieres recibir nuestras ofertas? ¡Registrate ya mismo y comenzá a disfrutarlas!",
  successMessage = "¡Gracias por suscribirte! Pronto recibirás nuestras ofertas."
}: NewsletterSignupProps) {
  const [email, setEmail] = useState("");
  const theme = useTheme();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Email submitted:", email);
    alert(successMessage);
    setEmail("");
  };

  return (
    <Box 
      sx={{ 
        backgroundColor: theme.colors.background.paper,
        py: 8,
        px: 2,
        textAlign: 'center'
      }}
    >
      <Typography 
        variant="h2" 
        component="h2" 
        gutterBottom
        sx={{ 
          fontWeight: 700,
          fontSize: '40px',
          fontFamily: '"Rubik", sans-serif',
          color: theme.colors.text.primary,
          mb: 4
        }}
      >
        {title}
      </Typography>
      
      <Typography 
        variant="body2" 
        component="p" 
        gutterBottom
        sx={{ 
          color: theme.colors.text.primary,
          mb: 4,
          fontFamily: '"Rubik", sans-serif',
          fontSize: '14px',
          maxWidth: 600,
          mx: 'auto'
        }}
      >
        {description}
      </Typography>
      
      <Box 
        component="form" 
        onSubmit={handleSubmit}
        sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          maxWidth: 968,
          mx: 'auto',
        }}
      >
        <TextField
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          sx={{
            width: '100%',
            '& .MuiOutlinedInput-root': {
              backgroundColor: theme.colors.background.paper,
              color: theme.colors.text.primary,
              height: '40px',
              fontFamily: '"Rubik", sans-serif',
              '& fieldset': {
                border: 'none',
                borderBottom: `1px solid ${theme.colors.text.secondary}`,
              },
              '&:hover fieldset': {
                border: 'none',
                borderBottom: `1px solid ${theme.colors.text.secondary}`,
              },
              '&.Mui-focused fieldset': {
                border: 'none',
                borderBottom: `2px solid ${theme.colors.text.secondary}`,
              },
            },
            '& .MuiInputBase-input': {
              height: '16px',
              padding: '12px 14px',
              fontFamily: '"Rubik", sans-serif',
              fontSize: '14px',
              color: theme.colors.text.primary,
              '&::placeholder': {
                fontSize: '14px',
                opacity: 0.7,
                color: theme.colors.text.secondary,
              },
            },
          }}
        />
        
        <Button 
          type="submit"
          variant="contained"
          sx={{...BUTTON_STYLES.primary, width: 'auto !important'}}
        >
          ENVIAR
        </Button>
      </Box>
    </Box>
  );
}














